import React, { MutableRefObject } from 'react';
import { Grid } from '@material-ui/core';

import ScrollSpeedAction from '../actions/ScrollSpeedAction';
import PlayPrompterAction from '../actions/PlayPrompterAction';
import HomeAction from '../actions/HomeAction';
import BookMarkAction from '../actions/BookMarkAction';
import ExitStudioAction from '../actions/ExitStudioAction';
import SettingAction from '../actions/SettingAction';
import AudioLevel from '../actions/AudioLevel';
import HelpAction from '../actions/HelpAction';
import { StudioControlStyles } from '../styles';

type Props = {
  refPrompter: MutableRefObject<HTMLDivElement | null>;
};


const PrompterControlsDesktop = ({ refPrompter }: Props) => {
  const classes = StudioControlStyles();

  return (
    <>
      <Grid item container className={classes.mainControl}>
        <Grid item style={{ marginRight: 'auto' }}>
          <Grid item container spacing={3} style={{ margin: 'unset' }}>
            <ExitStudioAction />
            <HomeAction />
            <BookMarkAction
              refPrompter={refPrompter}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Grid item container spacing={3} style={{ margin: 'unset' }}>
            <PlayPrompterAction />
            <ScrollSpeedAction />
            <AudioLevel />
          </Grid>
        </Grid>
        <Grid item style={{ marginLeft: 'auto' }}>
          <Grid item container alignItems="center" style={{ height: '100%' }}>
            <HelpAction />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        container
        className={classes.settingActionContainer}
      >
        <SettingAction />
      </Grid>
    </>
  );
};

export default PrompterControlsDesktop;
